export default "__VITE_ASSET__Bs5cv_Dv__"